import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { HANDLE_UNCAUGHT_EXCEPTION } from 'actions/exceptions/handleUncaughtException';

export const FILE_UPLOAD_DELETE_REQUEST = 'FILE_UPLOAD_DELETE_REQUEST';
export const FILE_UPLOAD_DELETE_SUCCESS = 'FILE_UPLOAD_DELETE_SUCCESS';
export const FILE_UPLOAD_DELETE_FAILURE = 'FILE_UPLOAD_DELETE_FAILURE';

function request(id) {
  return {
    type: FILE_UPLOAD_DELETE_REQUEST,
    isDeletingUploadId: id
  };
}

function receive(id) {
  return {
    type: FILE_UPLOAD_DELETE_SUCCESS,
    isDeletingUploadId: id
  };
}

function reject(error) {
  return {
    type: HANDLE_UNCAUGHT_EXCEPTION,
    code: error.code,
    message: error.message
  };
}

export function deleteFileUpload(docId) {
  return (dispatch) => {
    dispatch(request(docId));

    const promise = () => ApiService
      .deleteFileUpload(docId)
      .then(() => {
        dispatch(receive(docId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          const status = error.response && error.response.data && error.response.data.code;
          dispatch(handleException(error, reject, !status || (status !== 404 && status !== 401)));
        }
      });

    return promise;
  };
}
